<script setup lang="ts">
import { useSubInstanceId } from "ls/state/useSubInstance";
import { computed } from "vue";
import { UserAxureRpRole, UserCloudRole } from "@/generated/models";
import { useOrganization } from "../organizations/useOrganization";
import { useCurrentUserInfo } from "../user/useAuth";
import LicenseTrial from "./LicenseTrial.vue";

const subInstanceId = useSubInstanceId();

const organizationData = useOrganization(subInstanceId);
const user = useCurrentUserInfo();
const showLicenseBanner = computed(() => subInstanceId.value
  && organizationData.value
  && (organizationData.value.CurrentUserCloudRole === UserCloudRole.Viewer || !organizationData.value.CurrentUserHasCloudSeatAssigned)
  && user.value
  && user.value.isRpEnterprise
  && user.value.axureRpRole !== UserAxureRpRole.Viewer
  && user.value.isRpEnterprise
  && !user.value.isWhitelisted,
);
</script>

<template>
  <template v-if="showLicenseBanner">
    <LicenseTrial />
  </template>
</template>
